<div class="content-inner background-section">
    <div class="dropdown dropdown-bhp exportBtn">
        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
            <div class="d-flex align-items-center">
                <img class="dropdown-arrow mr-2" src="assets/icons/downloadDarkOutlined.svg" />
                <label>{{ 'EVALUATION.EXPORT_REPORT_AS' | translate }}</label>
            </div>
            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
        </div>
        <ul class="dropdown-menu">
            <li class="dropdown-item" (click)="excelDownload()">{{ 'GENERAL.EXCEL' | translate }}</li>
            <li class="dropdown-item" (click)="saveReport()">{{ 'EVALUATION.PDF_DOCUMENT' | translate }}</li>
        </ul>
    </div>

    <lib-php-bhp-summarized-report-excel-export #exportTag class="col p-0"
        [frequencyDistribution]="nofrequencyFound ? [] : frequencyDistribution"
        [sopPredefinedComments]="nocommentsFound ? [] : predefinedComments"
        [processCompliance]="noDataFound ? [] : processCompliance"
        [subStepProcessCompliance]="nosubprocessFound ? [] : subStepProcessCompliance"
        [asepticStatistics]="noAsepticProcedures ? [] : asepticStatistics"
        [fiveMoments]="nofiveMomentsFilter ? [] : fiveMoments"
        [overallCompliance]="noOverallCompliance ? [] : overallCompliance"
        [observeComments]="noObserveComments ? [] : observeComments" [clickExcelBtn]="clickExcelBtn"
        [userData]="userData" [exportComponent]="sopReportExport" (childData)="emitData($event)"
        (resetClickBtn)="resetExportAs($event)"></lib-php-bhp-summarized-report-excel-export>

    <div class="col-12 static-card reportFiter" style="display: none;">
        <form class="form-container">
            <div class="row">
                <div class="col-md-7 col-sm-12">
                    <div class="form-group">
                        <label>{{ 'EVALUATION.SOP' | translate }}</label>
                        <select class="form-control">
                            <option value="0">{{ 'SOP_MANAGEMENT.INSERTION_INDWELLING_TRANSURETHRAL_URINARY_CATHETER' |
                                translate }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-12">
                    <div class="form-group">
                        <label>{{ 'EVALUATION.DATE' | translate }}</label>
                        <select class="form-control">
                            <option value="0">1/10/2018 - 1/10/2018</option>
                            <option value="0">1/10/2018 - 1/10/2018</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                        <label>{{ 'EVALUATION.GROUP_OR_INSTITUTION' | translate }}</label>
                        <select class="form-control">
                            <option value="0">University Hospital Humburg</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 col-sm-12">
                    <div class="form-group">
                        <label>{{ translationKeys.Configure.Ward | translate }}</label>
                        <select class="form-control">
                            <option value="0">Floor 02</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3 col-sm-12">
                    <div class="form-group">
                        <label>{{ translationKeys.Configure.Department | translate }}</label>
                        <select class="form-control">
                            <option value="0">Cardiology</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3 col-sm-12">
                    <div class="form-group">
                        <label>{{ 'CONFIGURE.PROFESSIONAL_CATEGORY' | translate }}</label>
                        <select class="form-control">
                            <option value="0">Medical Staff</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3 col-sm-12">
                    <div class="form-group">
                        <label>{{ 'CONFIGURE.PROFESSIONAL_SUB_CATEGORY' | translate }}</label>
                        <select class="form-control">
                            <option value="0">Physician</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col my-4">
                    <button class="btn-cancel-bordered-bd mr-4">{{ 'EVALUATION.SET_FILTER_1' | translate }}</button>
                    <button class="btn btn-cancel">{{ translationKeys.Authorization.Cancel | translate }}</button>
                </div>
            </div>
        </form>
    </div>
    <div class="p-4 report-container" [ngClass]="!isSOP ? 'hideSOP' : ''">
        <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                    <h1 class="section-title">HOLA2</h1>

                    <ul class="staticCardUlList" *ngIf="processComplianceFilter">
                        <!-- <li>{{processComplianceSopTittle | translate}}</li> -->
                        <li>{{ processComplianceFilter.filter[0].startDate | date:'dd/MM/yyyy'}}
                            -
                            {{ processComplianceFilter.filter[0].endDate | date:'dd/MM/yyyy' }}
                        </li>
                    </ul>

                </div>
                <div class="col-auto col-lg-4 d-flex justify-content-end IETooltip">
                    <a (click)="emitData({key:'processCompliance'})"
                        tooltip="{{'GENERAL.STATISTICAL_EVALUATION' | translate}} - {{'GENERAL.PROCESS_COMPLIANCE' | translate}}"
                        placement="left">
                        <img class="backArrow" src="assets/ph-bhp-layout/svg/icon-back-to-evaluation.svg">
                    </a>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-sm-12 col-lg-12">
                    <lib-ph-bhp-bar-chart *ngIf="!noDataFound" #processComplianceChart></lib-ph-bhp-bar-chart>
                    <div *ngIf="noDataFound">{{ translationKeys.Dashboard.NoDataFound | translate }}</div>
                </div>
                <div class="col-sm-12 col-lg-12 table-responsive mt-4" *ngIf="!noDataFound">
                    <bd-light-table *ngIf="gridData || []" [gridData]="gridData " [pageInfo]="pageInfoFrquency"
                        [fields]="fieldsFrequency" [classTable]="'frequency'" [showPaginator]="false"></bd-light-table>
                </div>
            </div>
        </div>
    </div>

    <div class="p-4 report-container" [ngClass]="!isSOP ? 'hideSOP' : ''">
        <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                    <h1 class="section-title">{{ 'EVALUATION.FREQUENCY_DISTRIBUTION.DISPLAY_TEXT' | translate }}</h1>
                    <ul class="staticCardUlList" *ngIf="frequencyDistributionFilter">
                        <li>{{frequencySopTittle | translate | labelSanitizer}}</li>
                        <li>{{ frequencyDistributionFilter.filter[0].startDate | date:'dd/MM/yyyy'}}
                            -
                            {{ frequencyDistributionFilter.filter[0].endDate | date:'dd/MM/yyyy' }}
                        </li>
                    </ul>
                </div>
                <div class="col-auto col-lg-4 d-flex justify-content-end IETooltip">
                    <a (click)="emitData({key:'frequencyDistribution'})"
                        tooltip="{{'GENERAL.STATISTICAL_EVALUATION' | translate}} - {{'GENERAL.FREQUENCY_DISTRIBUTION' | translate }}"
                        placement="left">
                        <img class="backArrow" src="assets/ph-bhp-layout/svg/icon-back-to-evaluation.svg">
                    </a>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-12">
                    <lib-ph-bhp-bar-chart *ngIf="!nofrequencyFound" #frequencyChart></lib-ph-bhp-bar-chart>
                    <div *ngIf="nofrequencyFound">{{ translationKeys.Dashboard.NoDataFound | translate }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="p-4 report-container" [ngClass]="!isSOP ? 'hideSOP' : ''">
        <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                    <h1 class="section-title">{{ 'EVALUATION.SUB_STEP_COMPLIANCE' | translate }}</h1>
                    <ul class="staticCardUlList" *ngIf="subStepProcessComplianceFilter">
                        <li>{{subStepProcessComplianceSopTittle | translate | labelSanitizer}}</li>
                        <!-- <li>{{ 'EVALUATION.All.STEPS' | translate }}</li> -->
                        <li>{{ subStepProcessComplianceFilter.filter[0].startDate | date:'dd/MM/yyyy'}}
                            -
                            {{ subStepProcessComplianceFilter.filter[0].endDate | date:'dd/MM/yyyy' }}
                        </li>
                    </ul>
                </div>
                <div class="col-auto col-lg-4 d-flex justify-content-end IETooltip">
                    <a (click)="emitData({key:'subStepCompliance'})"
                        tooltip="{{'GENERAL.STATISTICAL_EVALUATION' | translate }} - {{'GENERAL.SUB_STEP_COMPLIANCE' | translate }}"
                        placement="left">
                        <img class="backArrow" src="assets/ph-bhp-layout/svg/icon-back-to-evaluation.svg">
                    </a>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-12">
                    <lib-ph-bhp-bar-chart *ngIf="!nosubprocessFound" #subStepProcessChart></lib-ph-bhp-bar-chart>
                    <div *ngIf="nosubprocessFound">{{ translationKeys.Dashboard.NoDataFound | translate }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="p-4 report-container" [ngClass]="!isSOP ? 'hideSOP' : ''">
        <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                    <h1 class="section-title">{{ 'EVALUATION.SOP_COMMENTS' | translate }}</h1>
                    <ul class="staticCardUlList" *ngIf="predefinedCommentsFilter">
                        <!-- <li>{{predefinedCommentsSopTittle | translate}}</li> -->
                        <li>{{ predefinedCommentsFilter.filter?.startDate | date:'dd/MM/yyyy'}}
                            -
                            {{ predefinedCommentsFilter.filter?.endDate | date:'dd/MM/yyyy' }}
                        </li>
                    </ul>
                </div>
                <div class="col-auto col-lg-4 d-flex justify-content-end IETooltip">
                    <a (click)="emitData({key:'comments'})"
                        tooltip="{{'GENERAL.STATISTICAL_EVALUATION' | translate }} - {{ 'EVALUATION.SOP_COMMENTS' | translate }}"
                        placement="left">
                        <img class="backArrow" src="assets/ph-bhp-layout/svg/icon-back-to-evaluation.svg">
                    </a>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-12">
                    <lib-ph-bhp-bar-chart *ngIf="!nocommentsFound" #predefinedCommentsChart></lib-ph-bhp-bar-chart>
                    <div *ngIf="nocommentsFound">{{ translationKeys.Dashboard.NoDataFound | translate }}</div>
                </div>
            </div>
        </div>
    </div>


    <div class="p-4 report-container" [ngClass]="!isObserve ? 'hideObserve' : ''">
        <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                    <h1 class="section-title">{{'EVALUATION.OVERALL_COMPLIANCE' | translate }}</h1>
                    <ul class="staticCardUlList" *ngIf="overallComplianceFilter">
                        <li>{{ overallComplianceFilter?.filter[0]?.startDate | date:'dd/MM/yyyy'}}
                            -
                            {{ overallComplianceFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                        </li>
                    </ul>
                </div>
                <div class="col-auto col-lg-4 d-flex justify-content-end IETooltip">
                    <a (click)="emitData({key:'overallCompliance'})"
                        tooltip="{{'EVALUATION.STATISTICAL_EVALUATION' | translate}} - {{'EVALUATION.OVERALL_COMPLIANCE' | translate }}"
                        placement="left">
                        <img class="backArrow" src="assets/ph-bhp-layout/svg/icon-back-to-evaluation.svg">
                    </a>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-12">
                    <lib-ph-bhp-bar-chart #overallComplianceChart *ngIf="!noOverallCompliance"></lib-ph-bhp-bar-chart>
                    <div *ngIf="noOverallCompliance">{{"EVALUATION.NO_DATA_FOUND" | translate}}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="p-4 report-container" [ngClass]="!isObserve ? 'hideObserve' : ''">
        <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                    <h1 class="section-title">{{'EVALUATION.FIVE_MOMENTS' | translate }}</h1>
                    <ul class="staticCardUlList" *ngIf="fiveMomentsFilter">
                        <li>{{ fiveMomentsFilter?.filter[0]?.startDate | date:'dd/MM/yyyy'}}
                            -
                            {{ fiveMomentsFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                        </li>
                    </ul>
                </div>
                <div class="col-auto col-lg-4 d-flex justify-content-end IETooltip">
                    <a (click)="emitData({key:'fiveMoments'})"
                        tooltip="{{'EVALUATION.STATISTICAL_EVALUATION' | translate}} - {{ translationKeys.Dashboard.FiveMoments | translate }}"
                        placement="left">
                        <img class="backArrow" src="assets/ph-bhp-layout/svg/icon-back-to-evaluation.svg">
                    </a>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-12">
                    <lib-ph-bhp-bar-chart #fiveMomentsFilterChart *ngIf="!nofiveMomentsFilter"></lib-ph-bhp-bar-chart>
                    <div *ngIf="nofiveMomentsFilter">{{"EVALUATION.NO_DATA_FOUND" | translate}}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="p-4 report-container" [ngClass]="!isObserve ? 'hideObserve' : ''">
        <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                    <h1 class="section-title">{{'EVALUATION.STATISTICS_ASEPT' | translate }}</h1>
                    <ul class="staticCardUlList" *ngIf="asepticStatisticsFilter">
                        <li>{{ asepticStatisticsFilter?.filter[0]?.startDate | date:'dd/MM/yyyy'}}
                            -
                            {{ asepticStatisticsFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                        </li>
                    </ul>
                </div>
                <div class="col-auto col-lg-4 d-flex justify-content-end IETooltip">
                    <a (click)="emitData({key:'asepticProcedures'})"
                        tooltip="{{'EVALUATION.STATISTICAL_EVALUATION' | translate}} - {{'EVALUATION.STATISTICS_ASEPT' | translate }}"
                        placement="left">
                        <img class="backArrow" src="assets/ph-bhp-layout/svg/icon-back-to-evaluation.svg">
                    </a>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-12">
                    <lib-ph-bhp-bar-chart #asepticProceduresFilterChart
                        *ngIf="!noAsepticProcedures"></lib-ph-bhp-bar-chart>
                    <div *ngIf="noAsepticProcedures">{{translationKeys.Dashboard.NoDataFound | translate}}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="p-4 report-container" [ngClass]="!isObserve ? 'hideObserve' : ''">
        <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
                <div class="col-auto">
                    <h1 class="section-title">{{'EVALUATION.OBSERVE_COMMENTS' | translate }}</h1>
                    <ul class="staticCardUlList" *ngIf="observeCommentsFilter">
                        <li>{{ observeCommentsFilter?.filter[0]?.startDate | date:'dd/MM/yyyy'}}
                            -
                            {{ observeCommentsFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                        </li>
                    </ul>
                </div>
                <div class="col-auto col-lg-4 d-flex justify-content-end IETooltip">
                    <a (click)="emitData({key:'observeComments'})"
                        tooltip="{{'GENERAL.STATISTICAL_EVALUATION' | translate }} - {{'EVALUATION.OBSERVE_COMMENTS' | translate}}"
                        placement="left">
                        <img class="backArrow" src="assets/ph-bhp-layout/svg/icon-back-to-evaluation.svg">
                    </a>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-12">
                    <lib-ph-bhp-bar-chart #observeCommentsFilterChart *ngIf="!noObserveComments"></lib-ph-bhp-bar-chart>
                    <div *ngIf="noObserveComments">{{translationKeys.Dashboard.NoDataFound | translate}}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<lib-ph-bhp-pdf-sop-report #sopReportExport></lib-ph-bhp-pdf-sop-report>